import React from 'react';
import Navbar from '../components/Navbar';
import AvatarsHero from '../components/AvatarsHero';
import AvatarsFeatures from '../components/AvatarsFeatures';
import AvatarsIntegration from '../components/AvatarsIntegration';

const AvatarsPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <Navbar />
      <main>
        <AvatarsHero />
        
        {/* Value Prop Highlight - Matching Memories Layout */}
        <section className="py-24 bg-white border-y border-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6">
              Enterprise Power. <span className="text-indigo-600">Ultra Low-Cost.</span>
            </h2>
            <p className="text-gray-600 text-xl max-w-3xl mx-auto mb-10 leading-relaxed">
              By leveraging your own AWS Chime infrastructure, we eliminate middleman markup. You pay Amazon directly for what you use, while we provide the premium venue.
            </p>
            <div className="flex justify-center">
              <div className="bg-indigo-50 px-12 py-8 rounded-2xl border border-indigo-100 max-w-lg">
                <p className="text-indigo-600 font-black text-5xl mb-2">85%+</p>
                <p className="text-indigo-900 font-bold uppercase tracking-wider text-sm">Average Cost Savings</p>
              </div>
            </div>
          </div>
        </section>

        <AvatarsFeatures />
        <AvatarsIntegration />
              
      </main>
    </div>
  );
};

export default AvatarsPage;